import{forwardRef as r}from"react";import{jsx as a}from"react/jsx-runtime";import e from"react-text-mask";var t=r((r,t)=>a(e,{...r,placeholderChar:" ",mask:r.mask,guide:!0}));export{t as MaskedInput};
//# sourceMappingURL=MaskedInput.js.map